module.exports = __webpack_public_path__ + "img/safira.b1fb8af2.png";